import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { ReactComponent as NotFound } from "../assets/icons/404.svg";

const FOF = () => {
  const navigate = useNavigate();
  const [timer, setTimer] = useState(10);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (timer > 0) {
        setTimer((timer) => timer - 1);
      }
      if (timer === 0) {
        navigate("/");
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [timer]);
  return (
    <div className="min-h-screen p-8 flex flex-col items-center">
      <NotFound className=" max-h-1/2 max-w-full " />
      <h1 className="text-3xl">هذه الصفحة غير موجودة</h1>
      <Link className="text-main-color" to="/">
        العودة للصفحة الرئيسية{" "}
      </Link>
      <p className="text-sm text-gray-400">
        {" "}
        اعادة التوجيه تلقائيا بعد {timer} ثانية
      </p>
    </div>
  );
};

export default FOF;
